import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints, colors, fontWeights } from '@/styles'
import useSessionComplete from '@/hooks/use-session-complete'
import ListingCard from '@/components/listing-card'
import LockedListingCard from '@/components/listing-card/locked-listing-card'
import { useTermsDialogContext } from '@/components/terms-dialog/context'

const Wrapper = styled.div`
  margin: 0 auto;
  padding-bottom: 80px;
`

const Title = styled.h2`
  font-size: 24px;
  font-weight: ${fontWeights.medium};
  letter-spacing: -0.58px;
  line-height: 22px;
  padding-top: 40px;
  margin: 0 auto 30px;
  border-top: 1px solid ${colors.grey88};

  @media (max-width: 1150px) {
    max-width: 700px;
  }

  @media (max-width: 737px) {
    max-width: 330px;
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    font-size: 18px;
    text-align: center;
    letter-spacing: -0.44px;
  }
`

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 350px);
  grid-gap: 20px;
  justify-content: center;
  align-content: start;
  width: 100%;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    grid-template-columns: 1fr;
  }
`

const FeaturedListings = ({ listings = [] }) => {
  const { t } = useTranslation()
  const isLoggedIn = useSessionComplete()
  const { checkAgreementMismatch, isLoading } = useTermsDialogContext()
  const isAgreementMismatched = checkAgreementMismatch('trreb_agreements')
  const isLoadingAgreements = isLoading && isLoggedIn

  return (
    <Wrapper>
      <Title>
        {t(
          'b.listings.view.other_sponsored_listings.title',
          'Other Sponsored Listings for Rent'
        )}
      </Title>
      <GridWrapper>
        {listings.map((listing, i) => {
          const isImported = listing.public_viewing === false
          const isListingLocked =
            isImported &&
            (!isLoggedIn || isAgreementMismatched || isLoadingAgreements)
          return isListingLocked ? (
            <LockedListingCard
              listing={listing}
              key={listing.listing_id}
              favouriteButton
              featured
              featuredPosition={i + 1}
              height={230}
              infoHeight={145}
            />
          ) : (
            <ListingCard
              listing={listing}
              key={listing.listing_id}
              favouriteButton
              featured
              variant="featured"
              featuredPosition={i + 1}
              trackImpression={{
                enabled: true,
                page: 'company-page',
                section: 'listing-card',
                sponsored: true
              }}
            />
          )
        })}
      </GridWrapper>
    </Wrapper>
  )
}

export default FeaturedListings
